import React, { Component } from 'react';

import * as ColorHelper from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

const EDITING = 'editing';
const PUBLISHED = 'in_progress';
const COMPLETE = 'complete';

class SurveyStatus extends Component {
  render() {
    let color = ColorHelper.colors.RED;
    let status = this.props.status;
    if (status === EDITING) {
      color = ColorHelper.colors.GRAY;
      status = getTranslatedString('landlordPortal.surveys.editing');
    } else if (status === PUBLISHED) {
      color = ColorHelper.colors.YELLOW;
      status = getTranslatedString('landlordPortal.surveys.inProgress');
    } else if (status === COMPLETE) {
      color = ColorHelper.colors.GREEN;
      status = getTranslatedString('landlordPortal.surveys.completed');
    }

    return (
      <span>
        <span style={{ color }}>&#x25cf;</span> {status}
      </span>
    );
  }
}

export default SurveyStatus;
